module.exports = __webpack_public_path__ + "static/media/dark-theme-logo.8e7c4b43.png";